(function() {
  'use strict';

  // ---------------------------------------------------------------
  // Quick add: size buttons on product cards and in the cart drawer
  // ---------------------------------------------------------------

  document.addEventListener('click', function(e) {
    var trigger = e.target.closest('[data-pi-quick-add] .pi-quick-add__trigger');
    var sizeBtn = e.target.closest('[data-pi-add-variant]');

    // Plus icon tap (mobile)
    if (trigger) {
      e.preventDefault();
      e.stopPropagation();
      var container = trigger.closest('[data-pi-quick-add]');
      container.classList.toggle('is-active');
      return;
    }

    // Size button click
    if (sizeBtn) {
      e.preventDefault();
      e.stopPropagation();

      // Sold-out sizes stay clickable but don't add to cart (hook for a future back-in-stock form)
      if (sizeBtn.getAttribute('aria-disabled') === 'true' || sizeBtn.classList.contains('is-loading')) return;

      var variantId = sizeBtn.getAttribute('data-pi-add-variant');
      if (!variantId) return;

      sizeBtn.classList.add('is-loading');
      var originalText = sizeBtn.textContent;
      sizeBtn.textContent = '…';

      fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: [{
            id: parseInt(variantId, 10),
            quantity: 1
          }]
        })
      })
      .then(function(response) {
        if (!response.ok) throw new Error('Add to cart failed');
        return response.json();
      })
      .then(function() {
        sizeBtn.textContent = '✓';
        setTimeout(function() {
          sizeBtn.textContent = originalText;
          sizeBtn.classList.remove('is-loading');
        }, 1200);

        return fetch('/cart.js', {
          headers: { 'Accept': 'application/json' }
        });
      })
      .then(function(response) { return response.json(); })
      .then(function(cart) {
        // Update cart count indicators in the header
        var countEls = document.querySelectorAll('.js-cart-count');
        countEls.forEach(function(el) {
          el.classList.remove('hidden');
          var inner = el.querySelector('.quick-cart__indicator-inner');
          if (inner) inner.textContent = cart.item_count;
        });

        // If the drawer is already open, re-render it in place.
        // Otherwise open it via the header toggle.
        var drawerOpen = document.querySelector('[data-cart-drawer].is-visible');

        if (drawerOpen) {
          document.dispatchEvent(new CustomEvent('flu:cart:updated', {
            detail: { cart: cart }
          }));
        } else {
          var cartToggle = document.querySelector('.js-cart-drawer-toggle');
          if (cartToggle) cartToggle.click();
        }
      })
      .catch(function() {
        sizeBtn.textContent = '!';
        setTimeout(function() {
          sizeBtn.textContent = originalText;
          sizeBtn.classList.remove('is-loading');
        }, 1500);
      });

      return;
    }
  }, true);

  // Close mobile size picker when tapping outside
  document.addEventListener('click', function(e) {
    if (!e.target.closest('[data-pi-quick-add]')) {
      document.querySelectorAll('.pi-quick-add.is-active').forEach(function(el) {
        el.classList.remove('is-active');
      });
    }
  });

  // Collapse / expand the "You may also like" block
  document.addEventListener('click', function(e) {
    var toggle = e.target.closest('[data-upsell-toggle]');
    if (!toggle) return;
    e.preventDefault();
    var block = toggle.closest('[data-cart-upsell]');
    if (!block) return;
    var collapsed = block.classList.toggle('is-collapsed');
    toggle.setAttribute('aria-expanded', String(!collapsed));
  });

  // ---------------------------------------------------------------
  // Cart drawer: item count, free shipping bar, upsell filtering
  // ---------------------------------------------------------------

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }
  function updateCount(cart) {
    var count = cart.item_count || 0;
    document.querySelectorAll('[data-cart-count]').forEach(function(el) {
      el.textContent = count;
    });
    document.querySelectorAll('[data-cart-count-label]').forEach(function(el) {
      el.textContent = count === 1 ? 'item' : 'items';
    });
  }

  function updateShippingBar(cart) {
    var bar = document.querySelector('[data-shipping-bar]');
    var inner = document.querySelector('[data-quick-cart]');
    if (!bar || !inner) return;

    var threshold = parseInt(inner.getAttribute('data-shipping-threshold'), 10);
    var total = cart.total_price || 0;

    if (!cart.item_count || !threshold) {
      bar.hidden = true;
      return;
    }

    bar.hidden = false;

    var remaining = threshold - total;
    var pct = Math.min((total / threshold) * 100, 100);
    var text = bar.querySelector('[data-shipping-text]');
    var fill = bar.querySelector('[data-shipping-fill]');

    if (text) {
      text.innerHTML = remaining > 0
        ? 'Spend <strong>' + formatMoney(remaining) + '</strong> more for <strong>free shipping</strong>'
        : '<strong>Free shipping unlocked</strong>';
    }

    if (fill) fill.style.width = pct + '%';
  }

  function updateUpsell(cart) {
    var block = document.querySelector('[data-cart-upsell]');
    if (!block) return;

    var items = cart.items || [];
    var ids = items.map(function(i) { return String(i.product_id); });
    var visible = 0;

    block.querySelectorAll('[data-upsell-product]').forEach(function(el) {
      var inCart = ids.indexOf(el.getAttribute('data-upsell-product')) !== -1;
      el.classList.toggle('is-hidden', inCart);
      if (!inCart) visible++;
    });

    block.classList.toggle('is-empty', visible === 0);

    // Reset scroll so the first visible card is in view
    var track = block.querySelector('[data-cart-upsell] .quick-cart__upsell-track')
             || block.querySelector('.quick-cart__upsell-track');
    if (track) track.scrollLeft = 0;
  }

  function updateDrawer(cart) {
    if (!cart || typeof cart.item_count === 'undefined') return;
    updateCount(cart);
    updateShippingBar(cart);
    updateUpsell(cart);
  }

  document.addEventListener('flu:cart:updated', function(e) {
    if (e.detail && e.detail.cart) updateDrawer(e.detail.cart);
  });

  document.addEventListener('flu:cart:item-added', function() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r) { return r.json(); })
      .then(updateDrawer)
      .catch(function() {});
  });

  document.addEventListener('flu:quick-cart:open', function(e) {
    if (e.detail && e.detail.cart) updateDrawer(e.detail.cart);
  });

  // Initial state on page load
  fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
    .then(function(r) { return r.json(); })
    .then(updateDrawer)
    .catch(function() {});
})();